import GET_VENTURE from "./getVenture";

export default {
  GET_VENTURE,
};
